import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function TextEditor({ value, onChange, disabled }) {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean']
    ]
  };

  return (
    <div className="w-full">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        readOnly={disabled}
        className={`w-full rounded-md text-md min-h-[120px] sm:min-h-[180px] ${disabled ? 'hide-toolbar' : ''
          }`}
      />
      <style jsx>{`
        .hide-toolbar .ql-toolbar {
          display: none !important;
          border-top: 1px solid !important;
        }
        .hide-toolbar  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border: 0px solid #ccc !important;    
}
    .hide-toolbar .ql-editor {
        padding: 0px !important;
      }
          .hide-toolbar  {
          min-height: auto !important;
        }
      `}</style>
    </div>
  );
}

export default TextEditor;